import {
  Actions,
  NotificationType,
} from 'ha/modules/RealtimeMessaging/constants';

export default action =>
  action.type === Actions.RECEIVE_MESSAGE &&
  action.payload.type === NotificationType.conversationRead;
